import React, {useEffect} from "react";
import "../styles/About.css";
import vission from "../assets/vission.jpeg"

export default function Vission() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);
  return (
    <div className="mission-container">
      <div className="Mission-div">
        <h2>Vission</h2>
        <img src={vission} alt="two hands" />
        <p>
          To be a leading provider of innovative drone solutions in South
          Africa, revolutionizing industries through cutting-edge technology and
          unpaaralleled expertise. We aspire to empower businesses by integrating
          advanced aerial data collection and analysis into their operations,
          driving efficiency and enhancing decision-making processes. Our vision
          is to create a future where drone technology not only transforms
          traditional practices but also contributes to sustainable development
          and growth across various sectors, including agriculture,
          construction, and environmental monitoring. We aim to foster a
          community of skilled remote pilots, championing education and
          awareness around drone capabilities, while upholding the highest
          standards of safety and professionalism in all our endeavors.
        </p>
      </div>
    </div>
  );
}
